import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MaterialIcon, Button } from '@pearsontechnology/aero-components';

const ExpandButton = styled(({ expanded, ...rest }) => (
  <Button iconOnly grey iconOnlySize={34} {...rest}>
    <MaterialIcon id={expanded ? 'expand_less' : 'expand_more'} />
  </Button>
))`
  margin-right: 5px;
`;

ExpandButton.propTypes = {
  expanded: PropTypes.bool,
};

export default ExpandButton;
